module.exports = __webpack_public_path__ + "img/ic_ios_link_tip.b62d9d36.png";